module.exports = __webpack_public_path__ + "assets/fireExtinguisher.b569d6df.svg";